/** Values used in the Alarm Settings UI multi-select (match API flags). */
export const ALERT_REPORT_TYPE_VALUES = [
    "lowTemperature",
    "highTemperature",
    "noNodeCommunication",
    "noApCommunication",
    "reporting",
];
export function booleansToAlertReportTypes(r) {
    const out = [];
    if (r.allowLowTemp)
        out.push("lowTemperature");
    if (r.allowHighTemp)
        out.push("highTemperature");
    if (r.allowNoNode)
        out.push("noNodeCommunication");
    if (r.allowNoAp)
        out.push("noApCommunication");
    if (r.allowReporting)
        out.push("reporting");
    return out;
}
export function alertReportTypesToBooleans(types) {
    return {
        allowLowTemp: types.includes("lowTemperature"),
        allowHighTemp: types.includes("highTemperature"),
        allowNoNode: types.includes("noNodeCommunication"),
        allowNoAp: types.includes("noApCommunication"),
        allowReporting: types.includes("reporting"),
    };
}
